import React from "react";
import _ from "lodash";
import { Box } from "@mui/material";
import DirectMessageDetailsContainer from "./DirectMessageDetailsContainer";
import EmailDetailsContainer from "./EmailDetailsContainer";
import CommentDetailsContainer from "./CommentDetailsContainer";
import { isObjectEmpty, isTypeEmail, stripNumbersFromUsername } from "_helpers";

export default function InboxConversation({
  conversation,
  currentUser,
  messageId,
  companyReplied,
  markAsDone,
}) {
  const conversationList = _.get(conversation, "conversation") || [];
  const sourceName = _.get(conversation, "sourceName");
  const link = _.get(conversation, "link");
  const handleType = _.get(conversation, "dataSourceHandle.type");
  let displayInApp = _.get(conversation, "dataSourceHandle.displayInApp");
  const isEmail = isTypeEmail(handleType);
  const author = stripNumbersFromUsername(_.get(conversation, "author"));

  return (
    <Box pb="15px">
      {displayInApp && !isObjectEmpty(conversation) && (
        <>
          {isEmail ? (
            <EmailDetailsContainer
              messageId={messageId}
              conversation={conversation}
              author={author}
              currentUser={currentUser}
              companyReplied={companyReplied}
              markAsDone={markAsDone}
              link={link}
            />
          ) : (
            <DirectMessageDetailsContainer
              conversationList={conversationList}
              conversation={conversation}
              sourceName={sourceName}
              currentUser={currentUser}
              link={link}
              author={author}
              companyReplied={companyReplied}
              markAsDone={markAsDone}
              openedMessageId={messageId}
            />
          )}
        </>
      )}

      {!displayInApp && !isObjectEmpty(conversation) && (
        <CommentDetailsContainer
          conversation={conversation}
          currentUser={currentUser}
          link={link}
          sourceName={sourceName}
          author={author}
          messageId={messageId}
          companyReplied={companyReplied}
          markAsDone={markAsDone}
        />
      )}
    </Box>
  );
}
